import React, { useEffect, useRef } from "react";
import cn from "classnames";
import { translations } from "i18n";
import Lottie from "lottie-react";

import styles from "./style.module.scss";

import OBSTemplateWithoutDevices from "../common/components/OBSTemplateWithoutDevices";
import WheelOfFortuneRows from "../common/components/WheelOfFortuneRows";
import { useWheelOfFortune } from "hooks/WheelOfFortuneHook";

import imgLogo from "./img/logo.png";
import imgGift from "./img/gift.png";
import imgWin from "./img/win.png";

import blue from "./animations/blue.json";
import pink from "./animations/pink.json";
import white from "./animations/white.json";
import yellow from "./animations/yellow.json";

// wheel consist of 4 colored sectors
const animations = [blue, pink, white, yellow];

const settings = {
  imgGift,
  imgLogo,
  imgWin,
  giftStyle: { height: 90 },
  tipValueTextColor:
    "linear-gradient(to bottom, #fffbf0 1%, #ffa734 50%, #96804b)",
  tipValueTextFontSize: 48,
  tipValueTextFontFamily: "BalooBhai",
};

const WidgetComponent = ({ preset, tips, isPreview, widgetStep }) => {
  const animationRef = useRef();
  const { randomOption, getRandomOption, getRandomAnimationKey } =
    useWheelOfFortune();

  const render = () => {
    return (
      <>
        {(isPreview || widgetStep === 0) && (
          <div
            className={cn(
              styles.settingsContainer,
              styles.backgroundDefault,
              isPreview && styles.preview
            )}
          >
            <img className={styles.logo} src={settings.imgLogo} alt="" />
            <div className={styles.price}>
              {translations("WheelOfFortune.TipTokens", {
                amount: preset.buyIn,
              })}
            </div>
            <WheelOfFortuneRows
              preset={preset}
              isPreview={isPreview}
              settings={settings}
              showGiftImg
            />
          </div>
        )}
        {widgetStep === 1 && !isPreview && (
          <div
            className={cn(
              styles.settingsContainer,
              styles.backgroundSpinningWheel
            )}
          >
            <img className={styles.logo} src={settings.imgLogo} alt="" />
            <div className={styles.senderTipped}>
              {translations("WheelOfFortune.TippedTokens", {
                sender: tips[tips.length - 1]?.sender,
                amount: tips[tips.length - 1]?.amount,
              })}
            </div>
            <Lottie
              lottieRef={animationRef}
              animationData={animations[getRandomAnimationKey()]}
              autoplay={true}
              loop={false}
              className={styles.wheel}
            />
          </div>
        )}
        {widgetStep === 2 && !isPreview && (
          <div
            className={cn(styles.settingsContainer, styles.backgroundNoWheel)}
          >
            <img className={styles.logo} src={settings.imgLogo} alt="" />
            <img className={styles.win} src={settings.imgWin} alt="" />
            <div className={styles.description}>
              {translations("WheelOfFortune.AndThePrizeIs")}
            </div>
            <WheelOfFortuneRows
              preset={preset}
              isPreview={isPreview}
              settings={{ ...settings, tipValueTextFontSize: 60 }}
              indexWon={randomOption}
            />
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    if (widgetStep === 1) {
      getRandomOption(preset);
    }
  }, [widgetStep]);

  return (
    <OBSTemplateWithoutDevices
      tipSettingsRenderFunction={render}
      isPreview={isPreview}
    />
  );
};

export default WidgetComponent;
